import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useRecoilState, useSetRecoilState } from "recoil";
import { receiptStepState } from "../../../recoil/pageStep";
import { firstReceiptFormState } from "../../../recoil/receipt";

import {
  dayOptions,
  monthOptions,
  yearOptions,
  residentialAreaOptions,
} from "../../../static/options";
import InputText from "../../atoms/input/InputText";
import Select from "../../atoms/input/Select";
import FooterButtonGroup from "../layout/FooterButtonGroup";
import { phoneRegex, emailRegex } from "../../../api/regex";
import useReceiptActions from "../../../api/hooks/receipt";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { OVERSEA } from "../../../submodules/enum/type";

const InfoInsertForm = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const { register, watch, getValues } = useForm();
  const [receiptStep, setReceiptStep] = useRecoilState(receiptStepState);
  const setFirstReceiptForm = useSetRecoilState(firstReceiptFormState);
  const [applicationform, setApplicationForm] = useState({});
  const { uploadFile, fetchApplicationForm } = useReceiptActions();

  const { data: applicationList } = useQuery({
    queryKey: ["applicationform"],
    queryFn: () =>
      fetchApplicationForm({ uuid: "c9171b02-ff10-49c2-8112-82c14c911f8c" }),
    onSuccess: (res) => {
      if (!res?.data?.form) {
        alert("접수기간이 만료되었습니다.");
        navigate("/");
      }
      setApplicationForm(
        res?.data?.form.reduce(
          (obj, item) => Object.assign(obj, { [item.name]: item }),
          {}
        )
      );
    },
  });

  const bank_image = useRef();

  const uploadAction = async () => {
    const res = await uploadFile({
      type: "receipt",
      file: bank_image.current.files[0],
    });
  };

  const nextOnClick = () => {
    const req = {
      ...getValues(),
      uuid,
      name: watch("name").trim(),
      tel: watch("tel").trim(),
      birthday_YMD: `${watch("year")}${watch("month")}${watch("day")}`,
    };

    if (applicationform.email && !emailRegex.test(req.email)) {
      alert("이메일이 올바르지 않습니다.");
      return;
    }

    if (applicationform.tel && !phoneRegex.test(req.tel)) {
      alert("휴대폰 번호는 XXX-XXXX-XXXX 형태로 입력해주세요.");
      return;
    }

    if (applicationform.birthday_YMD && req.birthday_YMD.length !== 8) {
      alert("생년월일을 선택해주세요.");
      return;
    } else {
      for (let item of applicationList.data.form) {
        if (!req[item.name]) {
          alert(`${item.view_text}를 입력해주세요.`);
          return;
        }
      }

      setFirstReceiptForm(req);
      setReceiptStep(receiptStep + 1);
    }
  };

  return (
    <div>
      <div className="info-table-box">
        <table className="info-table">
          <caption>신청자 정보입력</caption>
          <tbody>
            {applicationform.name && (
              <tr>
                <td className="info-td">{applicationform.name.view_text}</td>
                <td className="input-td">
                  <InputText
                    className="name-input"
                    refs={{
                      ...register(applicationform.name.name, {
                        min: 2,
                        max: 30,
                      }),
                    }}
                  />
                </td>
              </tr>
            )}

            {applicationform.email && (
              <tr>
                <td className="info-td">{applicationform.email.view_text}</td>
                <td className="input-td">
                  <InputText
                    className="name-input"
                    refs={{
                      ...register(applicationform.email.name, {
                        min: 2,
                        max: 30,
                      }),
                    }}
                  />
                </td>
              </tr>
            )}

            {applicationform.tel && (
              <tr>
                <td className="info-td">{applicationform.tel.view_text}</td>
                <td className="input-td">
                  <InputText
                    className="name-input"
                    refs={{
                      ...register(applicationform.tel.name),
                    }}
                  />
                </td>
              </tr>
            )}

            {applicationform.birthday_YMD && (
              <tr>
                <td className="info-td">
                  {applicationform.birthday_YMD.view_text}
                </td>
                <td className="input-td">
                  <Select
                    placeholder="년"
                    options={yearOptions}
                    refs={{
                      ...register("year"),
                    }}
                    style={{ width: "100px" }}
                  />
                  <Select
                    placeholder="월"
                    options={monthOptions}
                    refs={{
                      ...register("month"),
                    }}
                    style={{ width: "100px" }}
                  />
                  <Select
                    placeholder="일"
                    options={dayOptions}
                    refs={{
                      ...register("day"),
                    }}
                    style={{ width: "100px" }}
                  />
                </td>
              </tr>
            )}

            {applicationform.company && (
              <tr>
                <td className="info-td">{applicationform.company.view_text}</td>
                <td className="input-td">
                  <InputText
                    className="name-input"
                    refs={{
                      ...register(applicationform.company.name),
                    }}
                  />
                </td>
              </tr>
            )}

            {/* {applicationform.dispatch_country && (
              <tr>
                <td className="info-td">
                  {applicationform.dispatch_country.view_text}
                </td>
                <td className="input-td">
                  <InputText
                    className="name-input"
                    refs={{
                      ...register(applicationform.dispatch_country.name),
                    }}
                  />
                </td>
              </tr>
            )}
            {applicationform.field_of_dispatch && (
              <tr>
                <td className="info-td">
                  {applicationform.field_of_dispatch.view_text}
                </td>
                <td className="input-td">
                  <InputText
                    className="name-input"
                    refs={{
                      ...register(applicationform.field_of_dispatch.name),
                    }}
                  />
                </td>
              </tr>
            )} */}
          </tbody>
        </table>
        <table className="info-table">
          <caption>기타 정보입력</caption>
          <tbody>
            {applicationform.grade && (
              <tr>
                <td className="info-td">{applicationform.grade.view_text}</td>
                <td>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.grade.name)}
                      value="5"
                    />
                    <span> AL 이상</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.grade.name)}
                      value="4"
                    />
                    <span> IH</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.grade.name)}
                      value="3"
                    />
                    <span> IM</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.grade.name)}
                      value="2"
                    />
                    <span> IL</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.grade.name)}
                      value="1"
                    />
                    <span> NH 이하</span>
                  </label>
                </td>
              </tr>
            )}
            {applicationform.gender && (
              <tr>
                <td className="info-td">성별</td>
                <td>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.gender.name)}
                      value="1"
                    />
                    <span>남</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.gender.name)}
                      value="2"
                    />
                    <span>여</span>
                  </label>
                </td>
              </tr>
            )}
            {applicationform.age_band && (
              <tr>
                <td className="info-td">연령</td>
                <td>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.age_band.name)}
                      value={20}
                    />
                    <span>20대</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.age_band.name)}
                      value={30}
                    />
                    <span>30대</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.age_band.name)}
                      value={40}
                    />
                    <span>40대</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      {...register(applicationform.age_band.name)}
                      value={50}
                    />
                    <span>50대</span>
                  </label>
                </td>
              </tr>
            )}
            {applicationform.residence && (
              <tr>
                <td className="info-td">거주지역</td>
                <td>
                  <Select
                    options={residentialAreaOptions}
                    refs={{
                      ...register(applicationform.residence.name),
                    }}
                  />
                </td>
              </tr>
            )}
            {applicationform.overseas_experience && (
              <tr>
                <td className="info-td">해외경험</td>
                <td>
                  <label>
                    <input
                      type="radio"
                      {...register("overseas_experience")}
                      value={OVERSEA.ONE}
                    />
                    <span>6개월 미만</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      {...register("overseas_experience")}
                      value={OVERSEA.TWO}
                    />
                    <span>6개월 ~ 1년 미만</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      {...register("overseas_experience")}
                      value={OVERSEA.THR}
                    />
                    <span>1년 이상</span>
                  </label>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <FooterButtonGroup
        prevOnClick={() => setReceiptStep(receiptStep - 1)}
        nextOnClick={() => nextOnClick()}
        nextSelect="selected"
      />
    </div>
  );
};

export default InfoInsertForm;
